export const StTableHead = [
	{ id: "actions", label: "Action(s)", sortOption: false },
	{ id: "part_number", label: "Part Number", sortOption: true },
	{ id: "serial_number", label: "Serial Number ", sortOption: true },
	{ id: "description", label: "Description", sortOption: true },
	{ id: "life_limit", label: "Life Limit", sortOption: false },
	{ id: "tsn", label: "TSN", sortOption: false },
	{ id: "csn", label: "CSN", sortOption: false },
	{ id: "life_remaining", label: "Life Remaining",sortOption: false },
	{ id: "remarks", label: "Remarks",sortOption: true },
	{ id: "attachments", label: "Attachments" },
];
